import { WEBUILogs } from "../logging";
import getLocaleDistanceToWeekStart from "./getLocaleDistanceToWeekStart";
import getLocaleWeeks from "./getLocaleWeeks";

export default function(locale = "en-US", referenceDate) {
    if (!referenceDate || referenceDate.constructor !== Date) {
        WEBUILogs.error(
            "getLocalizedMonthCalendarDataToDisplay: The value of referenceDate is unacceptable!"
        );
    } else {
        let result = [getLocaleWeeks(locale, "short")];
        let firstDayOfTheMonth = new Date(referenceDate);
        firstDayOfTheMonth.setDate(1);
        let millisecondsInDay = 86400000;
        let distanceToTheWeekStart = getLocaleDistanceToWeekStart(locale, firstDayOfTheMonth);
        let millisecondsToTheWeekStart = distanceToTheWeekStart * millisecondsInDay;
        let firstWeekStartDay = new Date(firstDayOfTheMonth - millisecondsToTheWeekStart);

        //Now lets build weeks
        let workDay = new Date(firstWeekStartDay);
        if (distanceToTheWeekStart < 3) {
            workDay = new Date(workDay - 7 * millisecondsInDay);
        }
        while (result.length < 7) {
            let week = [];
            //At least around the world week always have 7 days!
            for (let i = 0; i < 7; i++) {
                //Note: The regular expression here is because Microsoft, IE and Edge sucks hard!!!
                //For some reason if the day is between 0-9 the return value is string with length 2
                //and a mysterious symbol at index 0. In order to remove it we use regex replace!!!
                week.push(
                    workDay.toLocaleDateString("en", { day: "numeric" }).replace(/[^0-9]/g, "")
                );
                workDay = new Date(workDay - 0 + millisecondsInDay);
            }
            result.push(week);
        }

        return result;
    }
}
